<p>Switching products off means that your live and scheduled products will not be displayed to brokers until you switch them back on</p>
<p>Are you sure you want to switch products off?</p>
<div class="text-end">
  <button class="btn btn-2022--secondary" (click)="confirm(false)">No, go back</button>
  <button class="ms-3 btn btn-2022--secondary" (click)="confirm(true)">Yes</button>
</div>
